import React from 'react'
import PropTypes from 'prop-types'
import { Input, Tag } from 'antd'
import { DEFAULT_REASON, PRINT_INFO_MAX_LENGTH } from '../../helpers/print'

const FIELDS = [
    { key: 'receiver_name', label: 'Người nhận hàng' },
    { key: 'receiver_phone', label: 'Số điện thoại' },
    { key: 'receiver_address', label: 'Địa chỉ' },
    { key: 'reason', label: 'Lý do xuất kho', placeholder: DEFAULT_REASON },
]

const PrintReceiverForm = ({ value, source, disabled, onChange }) => {
    return (
        <div className='PrintReceiverForm no-print'>
            <div className='PrintReceiverForm__head'>
                <b>Thông tin người nhận trên phiếu này</b>
                {source && <Tag color='blue'>{source}</Tag>}
                <span className='PrintReceiverForm__note'>
                    Sửa ở đây chỉ áp dụng cho phiếu này, không đổi thông tin đối tác.
                </span>
            </div>

            <div className='PrintReceiverForm__grid'>
                {FIELDS.map(({ key, label, placeholder }) => (
                    <div key={key} className='PrintReceiverForm__field'>
                        <label htmlFor={`print-${key}`}>{label}</label>
                        <Input
                            id={`print-${key}`}
                            value={value[key]}
                            maxLength={PRINT_INFO_MAX_LENGTH[key]}
                            placeholder={placeholder}
                            disabled={disabled}
                            onChange={e => onChange(key, e.target.value)}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

PrintReceiverForm.propTypes = {
    value: PropTypes.object.isRequired,
    source: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
}

export default PrintReceiverForm
